import { render } from "./productsView.vue?vue&type=template&id=f5e8aca2&scoped=true"
import script from "./productsView.vue?vue&type=script&lang=js"
export * from "./productsView.vue?vue&type=script&lang=js"

import "./productsView.vue?vue&type=style&index=0&id=f5e8aca2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e8aca2"]])

export default __exports__